 const swiper = new Swiper(".mySwiper", {
  loop: false,
  speed: 800,
  spaceBetween: 20,
 autoplay:false,
 dots:true,
  breakpoints: {
    0: { slidesPerView: 1 },
    768: { slidesPerView: 2 },
    1200: { slidesPerView: 5 }
  }
});


const initProductThumbnail = () => {
  const thumbnailGallery = document.querySelectorAll('.thumbnail-list__item');

  const filterThumbnails = () => {
    const variantSelects = document.querySelectorAll('variant-selects .variant-option-input');

    // Hide all thumbnails first
    thumbnailGallery.forEach((galleryItem) => {
      galleryItem.style.display = 'none';
    });

    variantSelects.forEach((selectedVariant) => {
      // Only process the checked input
      if (!selectedVariant.checked) return;

      console.log(selectedVariant.value.toLowerCase(), "selected variant value");
      // let emptyStr = document.querySelector('.product__text.inline-richtext.key-benefits-class').textContent.trim();
      // let varinatSelectedText = document.querySelector('.product__text.inline-richtext.key-benefits-class').innerHTML.split('|').map(item => item.trim())[1].split(' ')[0];

    const element = document.querySelector(
  '.product__text.inline-richtext.key-benefits-class'
);

if (element) {

  let emptyStr = element.textContent.trim();

  // Split safely
  let parts = emptyStr.split('|').map(item => item.trim());

  // Make sure second part exists
  if (parts.length > 1) {

    // Get first word safely
    let variantSelectedText = parts[1].split(' ')[0];

    console.log(parts, "parts..");

    // Replace first word
    parts[1] = parts[1].replace(/^\S+/, variantSelectedText);

    console.log(parts[1], "parts[1]..");

    // Only update if selectedVariant exists
    if (
      typeof selectedVariant !== "undefined" &&
      selectedVariant.value
    ) {
      parts[1] = `${selectedVariant.value} FLAVOUR`;
    }

    // Join back
    let newStr = parts.join(' | ');

    element.textContent = newStr;

    console.log(newStr, "newstr...");
  }
}

      thumbnailGallery.forEach((galleryItem) => {
        const mediaAlt = galleryItem.getAttribute('data-media-alt');

        if (
          selectedVariant.value.toLowerCase() === mediaAlt ||
          mediaAlt === 'all' ||   // always show if alt is "all"
          mediaAlt === '' ||      // always show if alt is empty/blank
          mediaAlt === null       // ✅ always show if alt attribute is missing
        ) {
          console.log(mediaAlt, "thumbnail gallery data media alt...");
          galleryItem.style.display = '';
        }
      });
    });
  };

  // Run on initial load
  filterThumbnails();

  // Event delegation on document — survives DOM re-renders
  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      console.log("variant changed...");
      filterThumbnails();
    }
  });
};

initProductThumbnail();


document.addEventListener('DOMContentLoaded', function () {

 document.querySelectorAll('.custom-buy-now-btn').forEach(function (btn) {

  btn.addEventListener('click', async function () {

    const sectionId = btn.getAttribute('data-section-id');

    // Get variant ID
    const variantInput = document.querySelector(
      `#ProductSubmitButton-${sectionId}`
    )
      ?.closest('form')
      ?.querySelector('[name="id"]');

    const variantId = variantInput
      ? parseInt(variantInput.value)
      : null;

    // Get quantity
    const quantityInput = document.querySelector('[name="quantity"]');

    const quantity = quantityInput
      ? parseInt(quantityInput.value) || 1
      : 1;

    if (!variantId) {
      console.error('Variant ID not found');
      return;
    }

    // Prevent multiple clicks
    if (btn.disabled) return;

    // Store original text
    const originalText = btn.textContent;
    btn.dataset.originalText = originalText;

    // Show loading state
    btn.disabled = true;
    btn.textContent = 'Processing...';

    try {

      // Step 1: Clear existing cart
      await fetch('/cart/clear.json', {
        method: 'POST'
      });

      // Step 2: Add item with quantity
      const addRes = await fetch('/cart/add.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!addRes.ok) {

        const err = await addRes.json();

        alert(
          err.description ||
          'Could not add item. Please try again.'
        );

        btn.disabled = false;
        btn.textContent = originalText;

        return;
      }

      // Step 3: Redirect to checkout
      window.location.href = '/checkout';

    } catch (err) {

      console.error('Buy Now failed:', err);

      alert('Something went wrong. Please try again.');

      btn.disabled = false;
      btn.textContent = originalText;
    }
  });
});


// Reset button state when user comes back
window.addEventListener('pageshow', function () {

  document.querySelectorAll('.custom-buy-now-btn').forEach(function (btn) {

    btn.disabled = false;

    if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
    } else {
      btn.textContent = 'Buy Now';
    }

  });

});

});